import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import Form from '../Form';
import './VerifyPhoneModal.scss';

export default class VerifyPhoneModal extends Component {
    static get propTypes() {
        return {
            userId: PropTypes.number,
            phone: PropTypes.string,
            requestId: PropTypes.number,
            buyer: PropTypes.bool,
            sendCodeOnLoad: PropTypes.bool,
            onSuccess: PropTypes.func,
            action: PropTypes.string,
            forceConfirmation: PropTypes.bool,
        };
    }

    formRef = React.createRef();

    state = {
        isLoading: false,
        code: '',
        verificationError: '',
        allowResend: false,
        willAllowResendInSeconds: 0,
        isSuccessful: false
    };

    componentDidMount() {
        trackEvent('Proposal', 'incompleteSeenVerificationModal').withGA();

        if(this.props.forceConfirmation) {
            return this.handleSubmit();
        }

        if (this.props.sendCodeOnLoad) {
            this.sendCode();
        }
    }

    sendCode() {
        const resendDelaySeconds = 10;
        this.setState({
            allowResend: false,
            willAllowResendInSeconds: resendDelaySeconds
        });
        const countdownTimer = setInterval(() => {
            this.setState({willAllowResendInSeconds: this.state.willAllowResendInSeconds - 1});
        }, 1000);
        setTimeout(() => {
            this.setState({allowResend: true});
            clearInterval(countdownTimer);
        }, resendDelaySeconds * 1000);

        return $.post('send-verification-code-json', {
            userId: this.props.userId,
            phone: this.props.phone
        }).then(data => {
            checkAjax(data);
        }).fail(error => {
            defaultAjaxError(error);
        });
    }

    verifyCode() {
        const {requestId, buyer, userId, phone, forceConfirmation = false} = this.props;

        this.setState({verificationError: ''});

        return $.post('verify-phone-code-json', {
            requestId,
            buyer,
            userId,
            code: forceConfirmation? '-1' : this.state.code,
            phone,
            forceConfirmation
        }).then(data => {
            if (data.msg) {
                this.setState({
                    verificationError: data.msg,
                    isSuccessful: false
                });
            } else {
                trackEvent('Proposal', 'incompleteVerifiedPhone').withGA();
                return $.post('update-user-json', {userId, phone}).then(data => {
                    if (checkAjax(data)) {
                        this.handleSuccessfullVerification();
                    }
                });
            }
        }).fail(error => {
            defaultAjaxError(error);
        });
    }

    handleSuccessfullVerification = () => {
        const {action, buyer, onSuccess} = this.props;
        this.setState({isSuccessful: true});
        if (action) {
            switch (action) {
                case 'greeting':
                    trackEvent(
                        'Proposal',
                        buyer
                            ? 'phonelessBuyerLandedOnValidationConfirmationPopupAfterUnlockToRead'
                            : 'phonelessSellerLandedOnValidationConfirmationPopupAfterUnlockToRead'
                    );
                    break;
                case 'questionaire':
                    trackEvent(
                        'Proposal',
                        buyer
                            ? 'phonelessBuyerLandedOnValidationConfirmationPopupAfterUnlockGreeting'
                            : 'phonelessSellerLandedOnValidationConfirmationPopupAfterUnlockGreeting'
                    );
                    break;
                default:
                    trackEvent(
                        'Proposal',
                        buyer
                            ? 'phonelessBuyerLandedOnValidationConfirmationPopupAfterGetFullAccess'
                            : 'phonelessSellerLandedOnValidationConfirmationPopupAfterGetFullAccess'
                    );
                    break;
            }
        }
        if (onSuccess) {
            onSuccess();
        }
    }

    handleSubmit = () => {
        this.setState({isLoading: true});

        this.verifyCode().always(() => {
            this.setState({isLoading: false});
        });
    }

    handleResend = () => {
        this.setState({isLoading: true});

        this.sendCode().always(() => {
            this.setState({isLoading: false});
        });
    }

    handleCodeInput = event => {
        this.setState({
            code: returnNumbersOnly(event.target.value)
        });
    };

    render() {
        const {isLoading, code, verificationError, allowResend, willAllowResendInSeconds, isSuccessful} = this.state;

        return (
            <div className="modal nu-modal verify-phone-modal fade" role="dialog">
                <div className="nu-modal-content">
                    <div className="modal-dialog">
                        {isSuccessful ? (
                            <div className="modal-content">
                                <div className="modal-header pt-4x pt-6x-sm pl-8x-sm pr-8x-sm">
                                    <div className="modal-title text-center">
                                        <svg className="mb-5x" width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0)">
                                                <path d="M98.7544 45.2457L89.3663 80.2824L85.0872 72.8764L92.9104 43.6799C97.1835 27.7325 87.722 11.3391 71.7747 7.06598C55.8273 2.79291 39.4367 12.2593 35.1636 28.2067L29.3236 26.6418C34.4521 7.50191 54.1947 -3.89978 73.3385 1.22979C92.4823 6.35936 103.883 26.1058 98.7544 45.2457Z" fill="#F9F6F6"/>
                                                <path d="M92.9149 43.681L85.0917 72.8775L80.8203 65.4736L87.0787 42.1172C90.4817 29.4169 82.9174 16.3151 70.2132 12.9111C57.5091 9.50703 44.4073 17.0713 41.0043 29.7716L35.1642 28.2067C39.4373 12.2594 55.8318 2.79404 71.7791 7.06711C87.7265 11.3402 97.1879 27.7337 92.9149 43.681Z" fill="#DDDAEC"/>
                                                <path d="M23.8852 128H104.117C108.567 128 112.178 124.392 112.178 119.939V61.6743C112.178 57.2243 108.567 53.6128 104.117 53.6128H23.8852C19.4312 53.6128 15.8237 57.2243 15.8237 61.6743V119.939C15.8237 124.392 19.4312 128 23.8852 128Z" fill="#6EA0DD"/>
                                                <path d="M78.0335 95.9637H81.0848C83.6725 95.9637 85.7685 93.8556 85.7524 91.2679V90.9454V90.8769C85.7685 88.1521 83.5516 85.9232 80.8308 85.9232H76.8848C73.8698 85.9232 71.1652 83.6659 71.008 80.655C70.8387 77.4425 73.3941 74.7862 76.5704 74.7862H90.8069C93.4994 74.7862 95.5068 72.525 95.4745 69.8325C95.4745 69.8123 95.4745 69.7881 95.4745 69.7639C95.4745 69.7398 95.4745 69.7196 95.4745 69.6954C95.5068 67.0029 93.4994 64.7457 90.8069 64.7457H86.2038C83.1888 64.7457 80.4842 62.4885 80.327 59.4775C80.1577 56.265 82.7132 53.6088 85.8894 53.6088H104.116C108.566 53.6088 112.178 57.2163 112.178 61.6702V119.934C112.178 124.388 108.566 127.996 104.116 127.996H80.5084C77.4329 127.996 74.9379 125.501 74.9379 122.425C74.9379 119.35 77.4329 116.855 80.5084 116.855H87.9572C90.5328 116.855 92.6288 114.747 92.6167 112.171V112.111C92.6167 111.998 92.6207 111.885 92.6288 111.772C92.782 109.233 90.7666 107.093 88.2232 107.093H78.3479C75.3329 107.093 72.6283 104.835 72.4711 101.824C72.3058 98.62 74.8613 95.9637 78.0335 95.9637Z" fill="#6095D7"/>
                                                <path d="M51.8862 83.9401C51.8862 77.2491 57.3116 71.8278 63.9986 71.8278C70.6896 71.8278 76.1109 77.2531 76.1109 83.9401C76.1109 88.4062 73.6643 92.2676 70.0648 94.3676L71.7255 109.785H56.2676L57.9283 94.3676C54.3289 92.2676 51.8862 88.4102 51.8862 83.9401Z" fill="#214571"/>
                                                <path d="M28.0556 83.5371C30.2806 83.5371 32.0864 85.3388 32.0864 87.5678V110.761C32.0864 112.99 30.2806 114.791 28.0556 114.791C25.8307 114.791 24.0249 112.99 24.0249 110.761V87.5678C24.0249 85.3429 25.8307 83.5371 28.0556 83.5371Z" fill="#7FB5F8"/>
                                                <path d="M28.0556 66.8215C30.2806 66.8215 32.0864 68.6233 32.0864 70.8523V75.5723C32.0864 77.8013 30.2806 79.603 28.0556 79.603C25.8307 79.603 24.0249 77.8013 24.0249 75.5723V70.8523C24.0249 68.6233 25.8307 66.8215 28.0556 66.8215Z" fill="#7FB5F8"/>
                                                <rect x="16" y="38.8572" width="13.7143" height="2.28571" rx="1.14286" fill="#214571"/>
                                                <rect x="20.5713" y="29.7142" width="9.14286" height="2.28571" rx="1.14286" transform="rotate(15 20.5713 29.7142)" fill="#214571"/>
                                                <rect x="20.5713" y="48.0807" width="9.14286" height="2.28571" rx="1.14286" transform="rotate(-15 20.5713 48.0807)" fill="#214571"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0">
                                                    <rect width="128" height="128" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        You unlocked your full access!
                                    </div>
                                </div>
                                <div className="modal-body pl-6x-sm pr-6x-sm">
                                    <div className="message" style="text-align: center">
                                        Good job! Start by reviewing your agent proposals and choosing one or more to interview.
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-blue-gray-outline mt-4x"
                                        data-dismiss="modal">
                                        Close
                                    </button>
                                </div>
                                <div className="modal-footer"/>
                            </div>
                        ) : (
                            <div className="modal-content">
                                <div className="modal-header pt-4x pt-6x-sm pl-8x-sm pr-8x-sm">
                                    <div className="modal-title text-center">
                                        <svg className="mb-3x mb-4x-sm" width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M38.0801 30.6826V55.8829H41.4399C43.2882 55.8829 44.8002 54.3708 44.8002 52.5226V45.8029L38.0801 30.6826Z" fill="#6095D7"/>
                                            <path d="M41.4402 30.6826V52.5226C41.4402 54.3708 39.9282 55.8829 38.0804 55.8829H14.5605C12.7122 55.8829 11.2002 54.3708 11.2002 52.5226V45.8029L41.4402 30.6826Z" fill="#6EA0DD"/>
                                            <path d="M41.4399 0.21875H38.0801V20.3788L44.8002 6.9389V3.57861C44.8002 1.73077 43.2882 0.21875 41.4399 0.21875Z" fill="#6095D7"/>
                                            <path d="M41.4402 3.57861V20.3788L11.2002 6.9389V3.57861C11.2002 1.73077 12.7122 0.21875 14.5605 0.21875H38.0804C39.9282 0.21875 41.4402 1.73077 41.4402 3.57861Z" fill="#6EA0DD"/>
                                            <path d="M41.4401 45.803H44.8004V6.93896H41.4401L26.3203 26.371L41.4401 45.803Z" fill="#DDDAEC"/>
                                            <path d="M11.2002 6.93896H41.4402V45.803H11.2002V6.93896Z" fill="#F9F6F6"/>
                                            <path d="M30.2397 49.1628H26.8799V52.5227H30.2397C31.1669 52.5227 31.9197 51.7703 31.9197 50.8428C31.9197 49.9156 31.1669 49.1628 30.2397 49.1628Z" fill="#214571"/>
                                            <path d="M26.8802 49.1628C27.8074 49.1628 28.5602 49.9156 28.5602 50.8428C28.5602 51.7703 27.8074 52.5227 26.8802 52.5227H25.76C24.8329 52.5227 24.0801 51.7703 24.0801 50.8428C24.0801 49.9156 24.8329 49.1628 25.76 49.1628H26.8802Z" fill="#3A6CA9"/>
                                            <path d="M29.6803 4.41858H26.3204C25.8564 4.41858 25.4805 4.0426 25.4805 3.57861C25.4805 3.11505 25.8564 2.73865 26.3204 2.73865H29.6803C30.1443 2.73865 30.5203 3.11505 30.5203 3.57861C30.5203 4.0426 30.1443 4.41858 29.6803 4.41858Z" fill="#3A6CA9"/>
                                            <path d="M24.6406 10.2988L21.2803 15.815L24.6406 21.3307L28.0004 24.6906V10.2988H24.6406Z" fill="#DF7212"/>
                                            <path d="M0 10.2988H24.6401V21.3307H0V10.2988Z" fill="#F57F17"/>
                                        </svg>
                                        {!this.props.forceConfirmation ? 'Verify your number.' : 'Verifying your phone number...'}
                                    </div>
                                </div>
                                {!this.props.forceConfirmation && (
                                    <div className="modal-body pl-3x-sm pr-3x-sm">
                                        <div className="message">
                                            Please enter the code sent to <span className="text-semibold text-highlight">{returnPhoneFormat(this.props.phone)}</span>.
                                        </div>
                                        <Form
                                            className="code-form mt-3x mb-4x mb-6x-sm"
                                            validationOptions={{
                                                submitHandler: this.handleSubmit
                                            }}>
                                            <input
                                                type="tel"
                                                id="verifyPhoneModalCode"
                                                name="code"
                                                className="form-control digits required"
                                                placeholder="6-digit code"
                                                minLength="6"
                                                maxLength="6"
                                                autoComplete="off"
                                                autoCorrect="off"
                                                autoCapitalize="off"
                                                spellCheck="off"
                                                value={code}
                                                onInput={this.handleCodeInput}/>
                                            <label htmlFor="verifyPhoneModalCode" className="error" generated="true" style="display: none"/>
                                            {verificationError &&
                                                <label className="error">{verificationError}</label>
                                            }
                                            <button
                                                type="submit"
                                                className="btn btn-blue mt-2x"
                                                disabled={isLoading}
                                                onClick={() => {
                                                    trackEvent('Proposal', 'incompleteSubmittedPIN').withGA();
                                                }}>
                                                Verify
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-blue-gray-outline mt-2x"
                                                disabled={isLoading || !allowResend}
                                                onClick={() => {
                                                    trackEvent('Proposal', 'incompleteResentPIN').withGA();
                                                    this.handleResend();
                                                }}>
                                                Resend code
                                                {willAllowResendInSeconds > 0 &&
                                                    ' (wait ' + pluralize(willAllowResendInSeconds, 'second', 'seconds') + ')'
                                                }
                                            </button>
                                        </Form>
                                    </div>
                                )}
                                {isLoading &&
                                    <div className="loadingSpinner" style="display: block; margin: 0">
                                        <img src={global.imageBaseUrl + 'spinner.gif'} className="mt-6x"/>
                                    </div>
                                }
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
